/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_M_ExpInputs */

const es_nav_m_exp = /** @type {(inputs: Nav_M_ExpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Experiencias`)
};

const gl_nav_m_exp = /** @type {(inputs: Nav_M_ExpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Experiencias`)
};

const en_nav_m_exp = /** @type {(inputs: Nav_M_ExpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Experiences`)
};

/**
* | output |
* | --- |
* | "Experiences" |
*
* @param {Nav_M_ExpInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_m_exp = /** @type {((inputs?: Nav_M_ExpInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_M_ExpInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_nav_m_exp(inputs)
	if (locale === "en") return en_nav_m_exp(inputs)
	return es_nav_m_exp(inputs)
});